import React, { useState, useEffect } from "react";
import { FileText, Layers, Package, TrendingUp, History, Plus } from "lucide-react";
import TechnicalFilesList from "./TechnicalFilesList";
import SubRecipesList from "./SubRecipesList";
import BatchProductionList from "./BatchProductionList";
import FoodCostDashboard from "./FoodCostDashboard";
import StockMovementsHistory from "./StockMovementsHistory";
import "./TechnicalFilesPage.scss";
import usePersistedTab from "../../hooks/usePersistedTab";
import { PageHeader, HeaderAction } from "../../stock/StockUI";

const TABS = [
    { key: "technical-files", label: "Fiches techniques", Icon: FileText },
    { key: "sub-recipes", label: "Sous-recettes", Icon: Layers },
    { key: "batch-production", label: "Lots de production", Icon: Package },
    { key: "food-cost", label: "Food cost", Icon: TrendingUp },
    { key: "stock-history", label: "Historique déstockage", Icon: History },
];

// Tabs whose list has a « Nouveau » action in the page header
const CREATE_TABS = ["technical-files", "sub-recipes", "batch-production"];

const TechnicalFilesPage = ({ isDarkMode = false }) => {
    const [activeTab, setActiveTab] = usePersistedTab("tab_technical_files", "technical-files");
    // Bumped by the header « Nouveau » button, as on the Stock page
    const [createRequestKey, setCreateRequestKey] = useState(0);

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, [activeTab]);

    const listProps = { isDarkMode, createRequestKey };

    return (
        <div className="technical-files-page min-h-screen bg-white dark:bg-gray-900 text-gray-900 dark:text-gray-100">
            <PageHeader
                title="Fiches techniques"
                tabs={TABS}
                activeTab={activeTab}
                onTabChange={setActiveTab}
                actions={CREATE_TABS.includes(activeTab) && (
                    <HeaderAction icon={Plus} label="Nouveau" onClick={() => setCreateRequestKey(k => k + 1)}/>
                )}
            />

            {activeTab === "technical-files" && <TechnicalFilesList {...listProps} />}
            {activeTab === "sub-recipes" && <SubRecipesList {...listProps} />}
            {activeTab === "batch-production" && <BatchProductionList {...listProps} />}
            {activeTab === "food-cost" && <FoodCostDashboard isDarkMode={isDarkMode} />}
            {activeTab === "stock-history" && <StockMovementsHistory isDarkMode={isDarkMode} />}
        </div>
    );
};

export default TechnicalFilesPage;
